export default __webpack_public_path__ + "8ea5400d8e5b01510f5e6d7e93fe8411.png";